import { declareAllModules } from "@/legacy/_module_loader";

const ctx = require.context("@/legacy/modules/widgets/lib/", true, /\.(js|vue)/, "eager");
declareAllModules("/widgets/lib", ctx.keys(), ctx);
